<template>
  <a-card :title="title">
    <a-button slot="extra" @click="$router.go(-1)">返回</a-button>
    <a-table
      size="small"
      rowKey="rowKey"
      :columns="columns"
      :dataSource="items"
      :loading="loading"
      :pagination="pagination"
      :customRow="customRow"
      @change="tableChange"
    />
  </a-card>
</template>

<script>
import { receivedDetails } from '@/api/report'

const titles = { sales: '现结明细', collection: '收款明细', all: '实收明细' }

export default {
  data() {
    return {
      loading: false,
      items: [],
      pagination: { current: 1, total: 0, pageSize: 16 },
      columns: [
        { title: '类型', dataIndex: 'kind_display', width: 80 },
        { title: '单号', dataIndex: 'number', width: 160 },
        { title: '客户', dataIndex: 'client_name' },
        { title: '实收', dataIndex: 'amount', width: 120 },
        { title: '抹零', dataIndex: 'discount_amount', width: 100 },
        { title: '时间', dataIndex: 'create_time', width: 180 },
      ],
    }
  },
  computed: {
    kind() {
      return this.$route.query.kind || 'all'
    },
    title() {
      return titles[this.kind] || '实收明细'
    },
  },
  watch: {
    '$route.query': {
      handler() {
        this.pagination.current = 1
        this.list()
      },
    },
  },
  mounted() {
    this.list()
  },
  methods: {
    list() {
      const { start_date, end_date } = this.$route.query
      if (!start_date || !end_date) return
      this.loading = true
      receivedDetails({
        kind: this.kind,
        start_date,
        end_date,
        page: this.pagination.current,
        page_size: this.pagination.pageSize,
      }).then((data) => {
        this.pagination.total = data.count || 0
        this.items = (data.results || []).map((item) => ({
          ...item,
          rowKey: `${item.kind}-${item.id}`,
        }))
      }).finally(() => {
        this.loading = false
      })
    },
    tableChange(pagination) {
      this.pagination.current = pagination.current
      this.list()
    },
    customRow(record) {
      return {
        style: { cursor: 'pointer' },
        on: { click: () => this.open(record) },
      }
    },
    open(record) {
      if (record.kind === 'sales') {
        this.$router.push({ path: '/sale/sale_record_detail', query: { id: record.id } })
        return
      }
      this.$router.push({ path: '/finance/collection_detail', query: { id: record.id } })
    },
  },
}
</script>
